import Managers from './Managers';

export default Managers;



// WEBPACK FOOTER //
// ./src/pages/Managers/index.ts